export default function HeroBanner() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2e4b6d452288b8c9aa0846b464d20880.jpg"
          alt="Industrial Technology Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0D1B3E]/95 via-[#0D1B3E]/85 to-[#0066FF]/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-12 lg:px-20 py-24 md:py-32">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl">
            {/* Label */}
            <div className="mb-6 md:mb-8">
              <span className="text-[#0066FF] text-xs md:text-sm font-semibold tracking-[0.2em] uppercase">
                INDUSTRY LEADING SOLUTIONS
              </span>
            </div>

            {/* Headline */}
            <h1 className="text-4xl md:text-5xl lg:text-7xl font-extrabold text-white leading-[1.1] mb-6 md:mb-8">
              Advanced Equipment<br />
              For Modern<br />
              Technology Leaders
            </h1>

            {/* Subheading */}
            <p className="text-base md:text-lg lg:text-xl text-gray-300 leading-relaxed mb-8 md:mb-12 max-w-2xl">
              Delivering cutting-edge industrial solutions and superior technology equipment that drive operational excellence and innovation across industries worldwide.
            </p>

            {/* CTA Buttons */}
            <div className="flex items-center gap-4 md:gap-6">
              <button
                onClick={scrollToContact}
                className="px-6 md:px-10 py-3 md:py-4 bg-white text-[#0D1B3E] rounded-lg font-semibold text-base md:text-lg hover:shadow-2xl transition-all duration-300 whitespace-nowrap"
              >
                Get Started
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="hidden md:flex absolute bottom-12 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white text-sm font-medium">Scroll Down</span>
          <div className="w-6 h-6 flex items-center justify-center">
            <i className="ri-arrow-down-line text-white text-2xl"></i>
          </div>
        </div>
      </div>
    </section>
  );
}
